import {Component, inject} from '@angular/core';
import {AuthCard} from "@components/layout/auth/auth-card/auth-card";
import {Router} from '@angular/router';

@Component({
  selector: 'app-no-permission',
  imports: [
    AuthCard
  ],
  templateUrl: './no-permission.html',
  standalone: true,
  styleUrl: './no-permission.css'
})
export class NoPermission {

  private readonly router = inject(Router);
  private readonly from: string = history.state?.from ?? 'guard';

  onSubmit() {
    if (this.from === 'interceptor') {
      this.router.navigate(['/auth/login']);
    } else {
      this.router.navigate(['/']);
    }
  }
}
